export default __webpack_public_path__ + "static/media/down_arrow.55faff7b.svg";